import { createValidator, ErrorObject } from 'util/validation'
import { ConfiguracaoPeriodoModel } from 'view/configuracao-agenda/component/ConfiguracaoAgendaPanel'

export const cfgPeriodoValidator = createValidator({}, (value: ConfiguracaoPeriodoModel) => {
  const errors: ErrorObject<ConfiguracaoPeriodoModel> = {}

  if (value) {
    if (value.horarioInicial && !value.horarioFinal) {
      errors.horarioFinal = 'Preenchimento obrigatório'
    }
    if (value.horarioFinal && !value.horarioInicial) {
      errors.horarioInicial = 'Preenchimento obrigatório'
    }
    if (value.horarioInicial && value.horarioFinal && value.horarioInicial.localeCompare(value.horarioFinal) >= 0) {
      errors.horarioFinal = 'Deve ser posterior à Entrada'
    }
  }

  return errors
})
